document.addEventListener("DOMContentLoaded", () => {
  const toggle = document.querySelector("[data-bcs-mobile-toggle]");
  const drawer = document.querySelector("[data-bcs-mobile-drawer]");
  const closeButtons = document.querySelectorAll("[data-bcs-mobile-close]");

  if (!toggle || !drawer) return;

  const openDrawer = () => {
    drawer.classList.add("is-open");
    toggle.setAttribute("aria-expanded", "true");
    document.body.style.overflow = "hidden";
  };

  const closeDrawer = () => {
    drawer.classList.remove("is-open");
    toggle.setAttribute("aria-expanded", "false");
    document.body.style.overflow = "";
  };

  toggle.addEventListener("click", () => {
    const isOpen = drawer.classList.contains("is-open");
    if (isOpen) {
      closeDrawer();
    } else {
      openDrawer();
    }
  });

  closeButtons.forEach((button) => {
    button.addEventListener("click", closeDrawer);
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      closeDrawer();
    }
  });

  // Accordion for nav items with sub-links
  drawer.querySelectorAll("[data-bcs-accordion-toggle]").forEach((btn) => {
    const item = btn.closest(".bcs-mobile-drawer__item--has-children");
    if (!item) return;
    const sublist = item.querySelector(".bcs-mobile-drawer__sublist");
    if (!sublist) return;

    btn.addEventListener("click", () => {
      const isOpen = btn.getAttribute("aria-expanded") === "true";
      btn.setAttribute("aria-expanded", isOpen ? "false" : "true");
      sublist.classList.toggle("is-open", !isOpen);
    });
  });
});


document.addEventListener('DOMContentLoaded', () => {
  const wrapper = document.querySelector('.bcs-header-wrapper.is-sticky-enabled');
  const stickyShell = wrapper?.querySelector('.bcs-header__sticky-shell');

  if (!wrapper || !stickyShell) return;

  const setHeaderHeight = () => {
    const height = stickyShell.offsetHeight;
    wrapper.style.setProperty('--bcs-sticky-header-height', `${height}px`);
  };

  setHeaderHeight();
  window.addEventListener('resize', setHeaderHeight);
});

document.addEventListener("DOMContentLoaded", () => {
  const trustRoot = document.querySelector("[data-bcs-trust]");
  if (!trustRoot) return;

  const inner = trustRoot.querySelector(".bcs-header__trust-inner");
  const items = inner
    ? Array.from(inner.querySelectorAll(".bcs-header__trust-item"))
    : [];

  if (!items.length) return;

  if (items.length === 1) {
    items[0].classList.add("is-active");
    return;
  }

  const mqMobile = window.matchMedia("(max-width: 999px)");
  const mqReduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

  let index = 0;
  let timer = null;

  const clearTimer = () => {
    if (timer != null) {
      window.clearInterval(timer);
      timer = null;
    }
  };

  const applyMobile = () => {
    items.forEach((el, i) => {
      el.classList.toggle("is-active", i === index);
    });
  };

  const applyDesktop = () => {
    items.forEach((el) => el.classList.remove("is-active"));
  };

  const sync = () => {
    clearTimer();

    if (!mqMobile.matches) {
      applyDesktop();
      return;
    }

    index = 0;
    applyMobile();

    if (mqReduceMotion.matches) return;

    timer = window.setInterval(() => {
      index = (index + 1) % items.length;
      applyMobile();
    }, 4500);
  };

  if (typeof mqMobile.addEventListener === "function") {
    mqMobile.addEventListener("change", sync);
    mqReduceMotion.addEventListener("change", sync);
  } else {
    mqMobile.addListener(sync);
    mqReduceMotion.addListener(sync);
  }

  sync();
});

function initBcsDesktopNavDropdowns() {
  const mqDesktop = window.matchMedia("(min-width: 1000px)");
  const items = document.querySelectorAll("[data-bcs-nav-dropdown]");
  if (!items.length) return;

  const OPEN_DELAY = 80;
  const CLOSE_DELAY = 180;
  const timers = new WeakMap();

  const clearTimer = (item, type) => {
    const itemTimers = timers.get(item);
    if (!itemTimers?.[type]) return;
    window.clearTimeout(itemTimers[type]);
    itemTimers[type] = null;
  };

  const setTimer = (item, type, callback, delay) => {
    const itemTimers = timers.get(item) || {};
    clearTimer(item, type);
    itemTimers[type] = window.setTimeout(callback, delay);
    timers.set(item, itemTimers);
  };

  const setOpen = (item, open) => {
    const link = item.querySelector(".bcs-nav__link");
    const dropdown = item.querySelector(".bcs-nav__dropdown");
    if (!link || !dropdown) return;

    item.classList.toggle("is-open", open);
    link.setAttribute("aria-expanded", open ? "true" : "false");
    dropdown.setAttribute("aria-hidden", open ? "false" : "true");
  };

  const openDropdown = (item) => {
    if (!mqDesktop.matches) return;
    clearTimer(item, "close");
    setTimer(
      item,
      "open",
      () => {
        document.querySelectorAll("[data-bcs-nav-dropdown].is-open").forEach((openItem) => {
          if (openItem !== item) setOpen(openItem, false);
        });
        setOpen(item, true);
      },
      OPEN_DELAY
    );
  };

  const closeDropdown = (item) => {
    if (!mqDesktop.matches) return;
    clearTimer(item, "open");
    setTimer(item, "close", () => setOpen(item, false), CLOSE_DELAY);
  };

  items.forEach((item) => {
    const link = item.querySelector(".bcs-nav__link");
    const dropdown = item.querySelector(".bcs-nav__dropdown");
    if (!link || !dropdown) return;

    item.addEventListener("mouseenter", () => openDropdown(item));
    item.addEventListener("mouseleave", () => closeDropdown(item));

    item.addEventListener("focusin", () => {
      if (!mqDesktop.matches) return;
      clearTimer(item, "close");
      setOpen(item, true);
    });

    item.addEventListener("focusout", (event) => {
      if (!mqDesktop.matches) return;
      if (!item.contains(event.relatedTarget)) {
        setOpen(item, false);
      }
    });

    link.addEventListener("keydown", (event) => {
      if (!mqDesktop.matches) return;
      if (event.key === "Escape") {
        setOpen(item, false);
        link.focus();
      }
    });
  });

  document.addEventListener("click", (event) => {
    if (!mqDesktop.matches) return;
    items.forEach((item) => {
      if (!item.contains(event.target)) {
        clearTimer(item, "open");
        clearTimer(item, "close");
        setOpen(item, false);
      }
    });
  });
}

document.addEventListener("DOMContentLoaded", initBcsDesktopNavDropdowns);

function initBcsSearchSuggestions() {
  const wraps = document.querySelectorAll("[data-bcs-search]");
  if (!wraps.length) return;

  const supportsPredictiveSearch = () => {
    const features = document.getElementById("shopify-features");
    if (!features) return true;
    try {
      return JSON.parse(features.innerHTML).predictiveSearch !== false;
    } catch {
      return true;
    }
  };

  const buildSearchEndpoint = () => {
    const root = window.Shopify?.routes?.root ?? window.routes?.rootUrl ?? "/";
    const normalizedRoot = root.endsWith("/") ? root : `${root}/`;
    const suffix = supportsPredictiveSearch() ? "suggest" : "";
    return `${normalizedRoot}search${suffix ? `/${suffix}` : ""}`;
  };

  wraps.forEach((wrap) => {
    const form = wrap.querySelector(".bcs-search-form");
    const input = form?.querySelector('[name="q"]');
    const panel = wrap.querySelector(".bcs-search-suggestions");
    const inner = wrap.querySelector(".bcs-search-suggestions__inner");

    if (!form || !input || !panel || !inner) return;

    let debounceTimer = null;

    const setOpen = (open) => {
      panel.hidden = !open;
      input.setAttribute("aria-expanded", open ? "true" : "false");
      wrap.classList.toggle("is-open", open);
    };

    const close = () => {
      setOpen(false);
      wrap.classList.remove("is-loading");
    };

    const fetchSuggestions = () => {
      const query = input.value.trim();
      if (!query) {
        inner.innerHTML = "";
        close();
        return;
      }

      const requestQuery = query;
      setOpen(true);
      wrap.classList.add("is-loading");

      const params = new URLSearchParams({
        section_id: "bcs-predictive-search",
        q: requestQuery,
        "resources[type]": "product",
        "resources[limit]": "6",
        "resources[limit_scope]": "each",
        "resources[options][fields]":
          "title,product_type,variants.title,variants.sku,vendor",
      });

      fetch(`${buildSearchEndpoint()}?${params.toString()}`, {
        method: "GET",
        credentials: "same-origin",
      })
        .then((response) => response.text())
        .then((html) => {
          if (input.value.trim() !== requestQuery) return;

          const doc = new DOMParser().parseFromString(html, "text/html");
          const section = doc.querySelector(".bcs-search-ajax");
          inner.innerHTML = section ? section.innerHTML : "";
        })
        .catch(() => {
          if (input.value.trim() !== requestQuery) return;
          inner.innerHTML =
            '<p class="bcs-search-suggestions__empty">Unable to load suggestions. Try again.</p>';
        })
        .finally(() => {
          if (input.value.trim() === requestQuery) {
            wrap.classList.remove("is-loading");
          }
        });
    };

    input.addEventListener("input", () => {
      window.clearTimeout(debounceTimer);
      debounceTimer = window.setTimeout(fetchSuggestions, 250);
    });

    input.addEventListener("focus", () => {
      if (input.value.trim()) fetchSuggestions();
    });

    input.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        close();
        input.blur();
      }
    });

    form.addEventListener("submit", close);

    document.addEventListener("click", (event) => {
      if (!wrap.contains(event.target)) close();
    });
  });
}

document.addEventListener("DOMContentLoaded", initBcsSearchSuggestions);

(function () {
  const syncCartCountBadge = () => {
    const countEl = document.querySelector(
      ".bcs-header-actions__cart-slot .header__cart-count"
    );
    if (!countEl) return;
    const n = parseInt(countEl.textContent.trim(), 10);
    countEl.classList.toggle("is-zero", Number.isNaN(n) || n === 0);
  };
  document.addEventListener("DOMContentLoaded", syncCartCountBadge);
  document.addEventListener("theme:loading:end", syncCartCountBadge);
})();